import { render, staticRenderFns } from "./SummaryPage.vue?vue&type=template&id=1c70219b&scoped=true"
import script from "./SummaryPage.vue?vue&type=script&lang=js"
export * from "./SummaryPage.vue?vue&type=script&lang=js"
import style0 from "./SummaryPage.vue?vue&type=style&index=0&id=1c70219b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c70219b",
  null
  
)

export default component.exports